import { Controller } from '@hotwired/stimulus';
import RefundForms from '../modules/refund_forms';

// The refund form's payment-method fields are wired by the module this wraps.
// As a controller it runs again whenever the form comes back from the server
// with errors, which the js.erb response used to do by calling the module
// through a global.
export default class extends Controller {
  connect() {
    RefundForms();
  }
}
